import { render } from "./Legend.vue?vue&type=template&id=6051918e"
import script from "./Legend.vue?vue&type=script&lang=js"
export * from "./Legend.vue?vue&type=script&lang=js"

import "./Legend.vue?vue&type=style&index=0&id=6051918e&lang=css"
script.render = render

export default script